import { defineComponent, openBlock, createElementBlock, Fragment, createVNode, h } from "vue";
import { usePopoverController } from "./src/composables/usePopoverController/index.mjs";
import { B as BPopover } from "./floatingUi-CsxgENev.mjs";
import { _ as _sfc_main$1 } from "./BTooltip.vue_vue_type_script_setup_true_lang-B1N8oaI-.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BPopoverOrchestrator",
  setup(__props, { expose: __expose }) {
    const tools = usePopoverController();
    const PopoverList = () => {
      var _a, _b;
      return Array.from(((_b = (_a = tools.popovers) == null ? void 0 : _a.value) == null ? void 0 : _b.entries()) ?? []).map(([self, { content, title, ...popover }]) => {
        const props = {};
        const slots = {};
        if (typeof content === "string") {
          props.content = content;
        } else {
          slots.default = content;
        }
        if (typeof title === "string") {
          props.title = title;
        } else {
          slots.title = title;
        }
        return h(BPopover, { key: self, ...props, ...popover }, slots);
      });
    };
    const TooltipList = () => {
      var _a, _b;
      return Array.from(((_b = (_a = tools.tooltips) == null ? void 0 : _a.value) == null ? void 0 : _b.entries()) ?? []).map(([self, { content, title, ...popover }]) => {
        const props = {};
        const slots = {};
        if (typeof content === "string") {
          props.content = content;
        } else {
          slots.default = content;
        }
        if (typeof title === "string") {
          props.title = title;
        } else {
          slots.title = title;
        }
        return h(_sfc_main$1, { key: self, ...props, ...popover }, slots);
      });
    };
    __expose({
      ...tools
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(PopoverList),
        createVNode(TooltipList)
      ], 64);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-DxYnyvsD.mjs.map
